import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import { SettingsManagerProvider } from '../settings-manager/settings-manager';
import { ProfilePage } from '../../app/modules/profile/components/profile/profile';
import { NavController } from '@ionic/angular';
import { UserManagerProvider } from '../user-manager/user-manager';
import { LoggerService } from '../../app/services/logger.service';

/*
  Generated class for the AccountManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AccountManagerProvider {
  public socketMgr: SocketManagerProvider;
  settingsMgr: SettingsManagerProvider;
  constructor(
    private userManager: UserManagerProvider,
    public http: HttpClient, public injector: Injector,
    private navCtrl: NavController,
    public logger: LoggerService
  ) {
    this.logger.debug('Hello AccountManagerProvider Provider');
    this.socketMgr = this.injector.get(SocketManagerProvider);
    this.settingsMgr = this.injector.get(SettingsManagerProvider);
    // this.getSubscriptionsStatus();
    this.checkUserAccount();


  }
  async getSubscriptionsStatus() {
    await this.userManager.getUser()
    this.socketMgr.asyncQuery("GetSubscriptionStatus", {}).then(response => {
      this.logger.debug('GetSubscriptionStatus', response);
    });
  }
  checkUserAccount() {
    this.userManager.getUser().then(user => {
      this.socketMgr.asyncQuery<GetUserStatusResponse, any>("getUserStatus", {}).then(response => {
        if (response.status == "Enabled") {
          this.settingsMgr.getPrimarySettings().then(settings => {
            settings.setBayaPlus(false);
            this.settingsMgr.savePrimarySetting();
          })
        } else if (response.status == "Disabled") {
          // this.app.getActiveNav().push(ProfilePage);
          this.navCtrl.navigateRoot("profile");
        } else if (response.status == "BayaPlus") {
          this.settingsMgr.getPrimarySettings().then(settings => {
            settings.setBayaPlus(true);
            this.settingsMgr.savePrimarySetting();
          })
        }


      })
    })
  }
}
interface GetUserStatusResponse {
  status: string;
}